import React from "react";
import All from "./all";

export default function DeliveryModes() {
  return (
    <div data-test="delivery-mode-page">
      <All />
    </div>
  );
}
